module.exports = __webpack_public_path__ + "img/102262.0a2427ef.svg";